<template>
  <div class="_wrapper" :class="{ 'is-active': isDropdownActive }">

    <!-- Category link block -->
    <div class="category-link">
      <router-link class="category-link-title no-underline"
                   :class="{ 'last-category': !item.children_data || item.children_data.length === 0 }"
                   :to="categoryLink(item)"
      > {{ item.name }} </router-link>
      <div class="category-link-total"> {{ item.product_count }} </div>
    </div>
    <!---->

    <!-- Category dropdown block -->
    <dropdown-block v-if="item.children_data && item.children_data.length && isDropdownActive" :list="item.children_data" />
    <!---->

  </div>
</template>

<script>
import DropdownBlock from 'theme/components/core/blocks/Shop/Sidebar/Dropdown/DropdownBlock'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapGetters } from 'vuex'

export default {
  components: {
    DropdownBlock
  },
  props: {
    // Category data
    item: {
      type: Object
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  mounted () {
    this.isDropdownActive = this.isCategoryActive
  },
  watch: {
    '$route.path': {
      handler: function () {
        this.isDropdownActive = this.isCategoryActive
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    },

    // Search for substring in the route
    isCategoryActive () {
      return this.$route.path.indexOf(this.item.url_path) !== -1
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  margin: 6px 0;

  &.is-active {
    & .category-link {
      position: relative;

      &:before {
        width: 2px;
        height: 100%;
        margin: auto;

        position: absolute;
        top: 0;
        left: -20px;
        bottom: 0;
        content: '';

        background: #f5a623;
        transition: .2s;
      }
    }

    & .category-link-title {
      color: #f5a623;
    }
  }

  & .category-link {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-title {
      color: #111;
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;

      transition: .2s;

      &.last-category {
        font-weight: 400;
      }

      &:hover {
        cursor: pointer;
        color: #f5a623;
      }
    }

    &-total {
      padding-left: 20px;

      color: #b4b4b4;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
}
</style>
